export const handleSalesDescription = (
  form,
  fieldName,
  value,
  formData,
  setFormData,
) => {
  setFormData({
    ...formData,
    [fieldName]: value,
  });
  form.setFieldsValue({
    [fieldName]: value,
  });
};

export const CalculatePercentageValueofSalesModal = (
  form,
  formData,
  setFormData,
) => {
  if (formData?.sMakingChargeType === 'percentage') {
    const percentage =
      (Number(formData?.grossWeight) *
        // Number(formData?.rate) *
        Number(
          (Number(formData?.rate) * Number(formData?.purity / 100)).toFixed(3),
        ) *
        Number(formData?.sMakingCharge)) /
      100;
    setFormData({
      ...formData,
      ...form.getFieldsValue(),
      sMakingAmount: Number(percentage).toFixed(3),
    });
    form.setFieldsValue({
      ...formData,
      ...form.getFieldsValue(),
      sMakingAmount: Number(percentage).toFixed(3),
    });
  } else if (formData?.sMakingChargeType === 'gm') {
    const value =
      Number(formData?.sMakingCharge) * Number(formData?.grossWeight);
    setFormData({
      ...formData,
      ...form.getFieldsValue(),
      sMakingAmount: value?.toFixed(3),
    });
    form.setFieldsValue({
      ...form.getFieldsValue(),
      sMakingAmount: value?.toFixed(3),
    });
  } else if (form.getFieldValue('sMakingChargeType') === 'rate') {
    const value =
      Number(form.getFieldValue('sMakingCharge')) *
      Number(form.getFieldValue('grossWeight'));
    setFormData({
      ...formData,
      ...form.getFieldsValue(),
      sMakingAmount: value?.toFixed(3),
    });
    form.setFieldsValue({
      ...form.getFieldsValue(),
      sMakingAmount: value?.toFixed(3),
    });
  }
};

export const wastageTypeSalesModalCalculataion = (
  form,
  formData,
  setFormData,
) => {
  let sWastageWeight = 0;
  if (form.getFieldValue('sWastageType') === 'gw') {
    sWastageWeight = Number(
      (form.getFieldValue('grossWeight') *
        form.getFieldValue('sWastageCharge')) /
        100,
    );
  } else if (form.getFieldValue('sWastageType') === 'nw') {
    sWastageWeight = Number(
      (form.getFieldValue('netWeight') * form.getFieldValue('sWastageCharge')) /
        100,
    );
  } else if (form.getFieldValue('sWastageType') === 'pw') {
    sWastageWeight = Number(
      (form.getFieldValue('pureWeight') *
        form.getFieldValue('sWastageCharge')) /
        100,
    );
  } else {
    sWastageWeight = formData?.sWastageWeight;
  }
  setFormData({
    ...formData,
    ...form.getFieldsValue(),
    sWastageWeight: Number(sWastageWeight).toFixed(3),
  });
  form.setFieldsValue({
    ...formData,
    ...form.getFieldsValue(),
    sWastageWeight: Number(sWastageWeight).toFixed(3),
  });
};
